import type { TranslationTree } from '../../types';

export const settings: TranslationTree = {
  globalSettings: {
    personalSpace: 'Personal space',
    title: 'Settings',
    description: 'Adjust the ToolLife experience and access your favorite shortcuts.',
    personalizationTitle: 'Personalization',
    personalizationDescription: 'Choose the theme that best suits your workspace.',
    quickNavigation: 'Quick navigation',
    noShortcut: 'No shortcut available for now.',
    securityReminder: 'To keep your data safe, remember to log out when leaving your workstation.',
    logoutCta: 'Log out',
    shortcuts: {
      adminTitle: 'Administration',
      adminDescription: 'Manage accounts, modules, and permissions across your organization.',
      toolsTitle: 'Tool navigator',
      toolsDescription: "Jump into the hierarchy and open any tool's detailed page.",
      profileTitle: 'User profile',
      profileDescription: 'Edit your personal information and preferences.',
    },
  },
};
